module.exports = __webpack_public_path__ + "img/cabinet_209.0fc3c3b8.jpg";